module.exports = __webpack_public_path__ + "img/func4.2c3d30b2.png";